export default "__VITE_ASSET__6872f156__"